import createPersistedReducer from '../../lib/createPersistedReducer.js';
import { createTransform } from 'redux-persist';
import setDeep from '../../lib/setDeep.js';
import { subDays } from 'date-fns';

const initialState = {
  fixedWidth: false,
  mobileComposerPaneActive: false,
  mobileHamburgerMenuActive: false,
  mobile: document.body.clientWidth < 640,
  boundForms: {},
  viewingRecord: [],
  routeKey: undefined,
  imagePopup: {
    index: undefined,
    images: [],
  },
  filters: {
    search: '',
    userId: undefined,
    locationId: undefined,
    reportsDateAggregate: 'day',
    reportsDateType: 'status',
    datePicker: {
      key: 'selection',
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
    },
    timestamps: {},
  },
};

const filterTimeouts = {
  datePicker: 1000 * 60 * 60 * 24 * 1,
};

const persistConfig = {
  key: 'uiReducer',
  whitelist: ['filters', 'imagePopup'],
  blackList: ['viewing_record'],
  transforms: [
    createTransform(
      (state, key) => {
        const newState = { ...state };
        if (key === 'filters') {
          for (const filterKey in filterTimeouts) {
            const diff = new Date() - new Date((state.timestamps || {})[filterKey]);
            if (diff > filterTimeouts[filterKey]) {
              delete newState[filterKey];
            }
          }
        }
        return newState;
      },
      (state) => state,
      { whitelist: 'filters' }
    ),
  ],
};

export default createPersistedReducer(
  initialState,
  {
    RESET_TO_INITIAL_STATE: (state) => {
      return {
        ...state,
        ...initialState,
        filters: {
          ...initialState.filters,
          globalSummaryDays: state.filters.globalSummaryDays,
        },
      };
    },

    viewing_record_SUCCESS: (state, payload) => {
      const userId = payload.event.viewing_record.userId;
      const data = payload.event.viewing_record;
      const clear = payload.event.viewing_record.clear;
      const viewingRecord = state.viewingRecord.filter((n) => {
        return n.userId !== userId;
      });
      if (clear !== true) {
        viewingRecord.push({ ...data });
      }

      return { ...state, viewingRecord };
    },
    uiSetMobileComposerPaneActive: (state, bool) => ({ ...state, mobileComposerPaneActive: bool }),
    uiSetMobileHamburgerMenuActive: (state, bool) => ({ ...state, mobileHamburgerMenuActive: bool }),
    uiSetSearch: (state, str) => ({ ...state, filters: { ...state.filters, search: str } }),
    uiSetRouteKey: (state, key) => ({ ...state, routeKey: key }),
    uiSetFormState: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.state`, (n) => ({
        ...payload.payload,
      })),
    }),
    uiSetForm: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.state`, (n) => ({
        ...n,
        [payload.key]: payload.value,
      })),
    }),
    uiSetFormInvalidField: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.invalids`, (n) => [...(n || [])].filter((n) => n.id !== payload.fieldId).concat({ id: payload.fieldId, message: payload.message })),
    }),
    uiRemoveFormInvalidField: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.invalids`, (n) => [...(n || [])].filter((n) => n.id !== payload.fieldId)),
    }),
    uiSetFormEmptyField: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.empties`, (n) => [...(n || [])].filter((n) => n !== payload.fieldId).concat(payload.fieldId)),
    }),
    uiRemoveFormEmptyField: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.empties`, (n) => [...(n || [])].filter((n) => n !== payload.fieldId)),
    }),
    uiPatchFormState: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.state`, (n) => ({
        ...n,
        ...payload.state,
      })),
    }),
    uiPutFormState: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.state`, (n) => ({
        ...payload.state,
      })),
    }),
    uiClearFormState: (state, formId) => ({
      ...setDeep(state, `boundForms.${formId}`, (n) => null),
    }),
    uiToggleFormValidation: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.validating`, (n) => payload.validating),
    }),
    uiToggleFormReset: (state, payload) => ({
      ...setDeep(state, `boundForms.${payload.formId}.reset`, (n) => payload.reset),
    }),
    uiPatchFilters: (state, payload) => ({
      ...state,
      filters: {
        ...state.filters,
        ...payload,
        timestamps: {
          ...(state.filters.timestamps || {}),
          ...Object.fromEntries(Object.entries(payload).map((n) => [n[0], new Date()])),
        },
      },
    }),
    uiPatchPipelineIdChange: (state, payload) => ({
      ...state,
      filters: { ...state.filters, ...payload, reportsPipelineStageId: null, reportsMilestoneStageId: null },
    }),
    uiResetPatchFilters: (state) => ({ ...state, filters: initialState.filters }),
    uiPatchImagePopup: (state, payload) => ({ ...state, imagePopup: { ...state.imagePopup, ...payload } }),
    uiClearDateCompareValue: (state, payload) => ({
      ...state,
      filters: { ...state.filers, paidAdsDateCompareDateValue: payload },
    }),
    uiResetPaidAdsData: (state) => {
      return {
        ...state,
        filters: {
          ...state.filters,
          paidAdsDateCompareDateValue: null,
        },
      };
    },
    uiSetFixedWidth: (state, bool) => ({ ...state, fixedWidth: bool }),
  },
  persistConfig
);
